import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CategoryDropdown from "./CategoryDropdown";
import Subscriptions from "./Subscriptions";


function Footer({lang}) {
  const { t } = useTranslation();


  return (
    <footer className="bg-gray-900 text-gray-100 p-10">
      <div className="container mx-auto grid grid-cols-1 gap-6 md:grid-cols-3">
        {/* Branding & Newsletter */}
        <div>
          <Link to={`/cm/${lang}`} className="flex items-center gap-2 text-2xl font-extrabold">
            <img
              src="https://proprimemart.com/237mechanic_real_logo.png"
              alt="237Mechanic Logo"
              className="h-20 w-auto"
            />
          </Link>
          <p className="mt-4 text-lg">
            {t("footer.description")}
          </p>
          <Subscriptions />
        </div>

        {/* Navigation Links */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <nav>
            <h6 className="footer-title text-xl font-bold mb-2">{t("footer.company")}</h6>
            <Link to={`/cm/${lang}`} className="block p-2 hover:underline">{t("nav.home")}</Link>
            <Link to={`/cm/${lang}/about-us`} className="block p-2 hover:underline">{t("nav.about")}</Link>
            <Link to={`/cm/${lang}/contact-us`} className="block p-2 hover:underline">{t("nav.contact")}</Link>
            <Link to={`/cm/${lang}/shop`} className="block p-2 hover:underline">{t("nav.shop")}</Link>
            <Link to={`https://marketplace.237mechanic.com/`} className="block p-2 hover:underline">{t("nav.marketplace")}</Link>
            <CategoryDropdown />
          </nav>
          <nav>
            <h6 className="footer-title text-xl font-bold mb-2">{t("footer.support")}</h6>
            <Link to={`/cm/${lang}/faq`} className="block p-2 hover:underline">{t("nav.faq")}</Link>
            <Link to={`/cm/${lang}/mechanics`} className="block p-2 hover:underline">{t("nav.mechanics")}</Link>
            <Link to={`/cm/${lang}/car-rentals`} className="block p-2 hover:underline">{t("nav.rentals")}</Link>
            <Link to={`/cm/${lang}/car-servicing`} className="block p-2 hover:underline">{t("nav.servicing")}</Link>
            <Link to={`/cm/${lang}/car-importation-consultation`} className="block p-2 hover:underline">{t("nav.importation")}</Link>
            <Link to={`/cm/${lang}/work-with-us`} className="block p-2 hover:underline">{t("nav.work")}</Link>
            <Link to={`/cm/${lang}/articles`} className="block p-2 hover:underline">{t("nav.articles")}</Link>
            <Link to={`/cm/${lang}/terms-and-conditions`} className="block p-2 hover:underline">{t("nav.terms")}</Link>
          </nav>
        </div>

        {/* Legal Info */}
        <div>
          <h6 className="footer-title text-xl font-bold mb-2">{t("footer.legal")}</h6>
          <p className="text-sm mb-4">{t("footer.disclaimer")}</p>
          <p className="text-sm">© {new Date().getFullYear()} 237Mechanic. {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
